import { formatDate, } from "../../_helpers";
import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";

const getGeneralSettings = (data,t) => {

    return [
        {
            title: t('general.startDate'),
            value: data?.startDate ? formatDate(new Date(data?.startDate), true, "-", false) || '' : ""
        },
        {
            title: t('general.endDate'),
            value: data?.endDate ? formatDate(new Date(data?.endDate), true, "-", false) || '' : ""
        },
        {
            title: t('general.description'),
            value: data?.desc ?  data?.desc : ""
        },
         {
            title: t('app.name.huisinfo'),
            value: data?.isBuyerGuidance ? <CheckBox color="disabled" /> : <CheckBoxOutlineBlank color="disabled" />
        }, {
            title: t('app.name.aftercare'),
             value: data?.isAftercare ? <CheckBox color="disabled" /> : <CheckBoxOutlineBlank color="disabled" />
        },
        {
            title: t('general.active'),
            value: data?.active ? <CheckBox color="disabled" /> : <CheckBoxOutlineBlank color="disabled" />
        }
    ]
}

export const getSystemAnnouncementInfo = (data,t)=> [
    {
        title:t('general.general'),
        tabIndex: 0,
        id: "general",
        details: getGeneralSettings(data,t),
        isHiddenEditIcon: true,
        type: "systemAnnouncement",
        isHiddenCheckBox: true,
        isDisabled: false
    },
    {
        id: "systemAnnouncement",
        type: "systemAnnouncement",
        isHiddenEditIcon: false,
        isPreviewDisplay: true,
        message: data?.message,
    },
     {
        id:"systemAnnouncementImage",
        type: "systemAnnouncementImage",
        isHiddenEditIcon: false,
        extraData:data,
        isImageDisplay: true,
    },
    
]